module.exports = __webpack_public_path__ + "img/IMG_8901.b9afc702.jpg";